import { map } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { createLoadOrder } from '../actions/order';
import { formatMoneyCurrency } from '../utils';
import { retrieveCreditMemo } from "../redux/credit_memos";
import { retrieveVendorCredit } from "../redux/vendor_credits";
import CreditMemoPopup from "./credit-memo/CreditMemoPopup";
import VendorCreditPopup from "./vendor-credit/VendorCreditPopup";

const ProjectMarginSummary = ({ project, order_id, force_subtotal = false }) => {
  const dispatch = useDispatch();
  const { invoices, margin_data } = project;
  const { total_subtotal, total_margin_amount, billed_margin, booked_margin } = (margin_data[order_id] || {});
  const [loadedInvoiceIds, setLoadedInvoiceIds] = useState(invoices.filter(i => i.loaded).map(i => i.order_id));

  useEffect(() => {
    map(invoices, (invoice) => {
      if (!loadedInvoiceIds.includes(invoice.order_id)) {
        setLoadedInvoiceIds(invoiceIds => invoiceIds.concat(invoice.order_id));
        dispatch(createLoadOrder(invoice.order_id));
      }
    });
  }, [invoices]);

  const [creditMemo, setCreditMemo] = useState();
  const [vendorCredit, setVendorCredit] = useState();

  const handleClickCreditMemo = credit_memo_id => async () => {
    const creditMemo = await dispatch(retrieveCreditMemo(credit_memo_id));
    setCreditMemo(creditMemo);
  };
  const handleCloseCreditMemo = () => setCreditMemo();
  const handleClickVendorCredit = vendor_credit_id => async () => {
    const vendorCredit = await dispatch(retrieveVendorCredit(vendor_credit_id));
    setVendorCredit(vendorCredit);
  };
  const handleCloseVendorCredit = () => setVendorCredit();
  

  return (
    <div className="large-4 column" style={{ padding: '2px' }}>
      {creditMemo && (
        <CreditMemoPopup creditMemo={creditMemo} onClose={handleCloseCreditMemo} isDisabled={true} />
      )}
      {vendorCredit && (
        <VendorCreditPopup vendorCredit={vendorCredit} onClose={handleCloseVendorCredit} isDisabled={true} />
      )}
      <table className="summary">
        <tbody>
        {project.invoices.length > 1 || force_subtotal ? <tr>
          <td>Subtotal (all invoices)</td>
          <td>{formatMoneyCurrency(total_subtotal, project.currency_id)}</td>
        </tr> : null}
        {project.credit_memos.map(
          (cm) => (
            <tr key={cm.credit_memo_id}>
              <td>
                <a onClick={handleClickCreditMemo(cm.credit_memo_id)}>
                  Credit Memo {cm.form_number}
                </a>
              </td>
              <td>{formatMoneyCurrency(-cm.total_subtotal, cm.currency_id)}</td>
            </tr>
          )
        )}
        {project.vendor_credits.map(
          (vc) => (
            <tr key={vc.vendor_credit_id}>
              <td>
                <a onClick={handleClickVendorCredit(vc.vendor_credit_id)}>
                  Vendor Credit {vc.form_number}
                </a>
              </td>
              <td>{formatMoneyCurrency(-vc.total_subtotal, vc.currency_id)}</td>
            </tr>
          )
        )}
        <tr>
          <td>Billed Margin Amount</td>
          <td>{formatMoneyCurrency(total_margin_amount, project.currency_id)}</td>
        </tr>
        <tr>
          <td>Billed Margin</td>
          <td>{parseFloat(billed_margin).toFixed(2)}%</td>
        </tr>
        <tr>
          <td>Booked Margin</td>
          <td>{parseFloat(booked_margin).toFixed(2)}%</td>
        </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ProjectMarginSummary;
